import { useMutation, useQuery, useQueryClient } from "react-query";
import useUserContext from "../contexts/UserContext";
import useApiHelper from "../services/useApiHelper";

export default function useValuationReports(agencyId) {
  const staleTime = 600000;
  const queryClient = useQueryClient();

  const { get, post, put, del } = useApiHelper();

  const valuationsStats = useQuery(
    ["valuationStats", agencyId],
    () => get(`/Reports/${agencyId}/valuationstats`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  return {
    valuationsStats,
  };
}
